import { Icon } from '@iconify/react';
import { TippyPopover } from './TippyTooltip';

export function WarnTooltip({ text }) {
	return <TippyPopover buttonComponent={<Icon icon='heroicons-solid:exclamation' className='h-5 w-5 text-orange-300' />}>
		<span>{text}</span>
	</TippyPopover>;
}
